import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import ROUTES from "../../utils/routes";
import Game from "../../store/Game";
import PersonalAccount from "../../store/PersonalAccount";
import { CURRENT_GAME_KEY } from "../../utils/constants";
import "./style.scss";

// item 20a / 10.10: при нажатии «Играть», когда 88 пройдены, а свои +57 нет,
// игрок выбирает: «Пройти +57» → свайпер +57; «Смотреть совпадения» → результаты.
// Повторяется каждый раз, пока игрок не пройдёт свои +57 (needsExtended57).
export default function Extended57ContinueModal() {
  const [payload, setPayload] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { closeModal } = useModalActions();

  const gameId = payload?.gameId;

  const goExtended = () => {
    closeModal(MODAL_TYPES.EXT57_CONTINUE);
    const eventGame = PersonalAccount.games?.find((g) => g.id === gameId);
    if (eventGame) {
      Game.setGame(eventGame);
      localStorage.setItem(CURRENT_GAME_KEY, JSON.stringify(eventGame));
    }
    // item 6: вход в +57 через страницу инструкции (из окна совпадений её не было)
    navigate(ROUTES.EXTENDED_57_INSTRUCTION_PAGE, {
      state: { gameId },
    });
  };

  const goResults = () => {
    closeModal(MODAL_TYPES.EXT57_CONTINUE);
    // 10.10: из ЛК приходит обычный путь к результатам (правила/ожидание партнёра)
    if (payload?.onResults) {
      payload.onResults();
      return;
    }
    const eventGame = PersonalAccount.games?.find((g) => g.id === gameId);
    if (eventGame) {
      Game.setGame(eventGame);
      localStorage.setItem(CURRENT_GAME_KEY, JSON.stringify(eventGame));
    }
    navigate(ROUTES.MATCHES_PAGE);
  };

  return (
    <BaseModal
      className="ext57-continue-modal"
      eventTypeModal={MODAL_TYPES.EXT57_CONTINUE}
      onPayload={(data) => data && setPayload(data)}
      description={t("extended57.continue.text")}
    >
      <div className="ext57-continue-modal__actions">
        <BaseButton onClick={goExtended}>
          {t("extended57.continue.yes")}
        </BaseButton>
        <BaseButton unfilledGradient onClick={goResults}>
          {t("extended57.continue.no")}
        </BaseButton>
      </div>
    </BaseModal>
  );
}
